import { setFavInstr } from '»utils/setFavInstr';

import { createAppSlice } from '../app.slice';

const initialState = {
  data: [],
  error: '',
};

export const userInstrumentsSlice = createAppSlice({
  name: 'userInstrumentsSlice',
  initialState,
  reducers: {
    userInstrumentsSucess: (state, action) => {
      state.data = action.payload;
    },
    setFavInstrumentRequest: () => {},
    setFavInstrumentSuccess: (state, action) => {
      const { option, instrument, symbol, exchange, securityType } =
        action.payload;

      const { updatedData } = setFavInstr({
        option,
        instrument,
        symbol,
        exchange,
        securityType,
        data: state.data,
        updateSelectedTitle: false,
      });

      state.data = updatedData;
    },
    setFavInstrumentFailure: (state, action) => {
      state.error = action.payload.error;
    },
    resetError: (state) => {
      state.error = '';
    },
  },
});
